module.exports = __webpack_public_path__ + "img/bj54.e0bb15a1.png";